/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Shared_Hosting_TaxService_Grpc_ParticpantsListTaxRateResponse } from '../models/Wealthlane_Shared_Hosting_TaxService_Grpc_ParticpantsListTaxRateResponse';
import type { Wealthlane_TaxService_Dtos_ParticipantTransaction_ParticipantDetailTransaction } from '../models/Wealthlane_TaxService_Dtos_ParticipantTransaction_ParticipantDetailTransaction';
import type { Wealthlane_TaxService_Dtos_ParticipantTransaction_ParticipantTransaction } from '../models/Wealthlane_TaxService_Dtos_ParticipantTransaction_ParticipantTransaction';
import type { Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxBracketsForCalculationDto } from '../models/Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxBracketsForCalculationDto';
import type { Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto } from '../models/Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto';
import type { Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseListDto } from '../models/Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseListDto';
import type { Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationTestBlobDto } from '../models/Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationTestBlobDto';
import type { Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationUsingImportDto } from '../models/Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationUsingImportDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TaxCalculationService {

    /**
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationParticipantTaxDetailForCompany(
requestBody?: Wealthlane_TaxService_Dtos_ParticipantTransaction_ParticipantDetailTransaction,
): CancelablePromise<Array<Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/participant-tax-detail-for-company',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationParticipantTaxDetailForParticipant(
requestBody?: Wealthlane_TaxService_Dtos_ParticipantTransaction_ParticipantDetailTransaction,
): CancelablePromise<Array<Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/participant-tax-detail-for-participant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taxItemId 
     * @param isExternalCall 
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationTaxCalculationOld(
taxItemId?: string,
isExternalCall: boolean = false,
requestBody?: Wealthlane_TaxService_Dtos_ParticipantTransaction_ParticipantTransaction,
): CancelablePromise<Array<Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/tax-calculation_old',
            query: {
                'TaxItemId': taxItemId,
                'isExternalCall': isExternalCall,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taxItemId 
     * @param isExternalCall 
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationTaxCalculation(
taxItemId?: string,
isExternalCall: boolean = false,
requestBody?: Wealthlane_TaxService_Dtos_ParticipantTransaction_ParticipantTransaction,
): CancelablePromise<Array<Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/tax-calculation',
            query: {
                'TaxItemId': taxItemId,
                'isExternalCall': isExternalCall,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sessionId 
     * @param taxItemId 
     * @param isExternalCall 
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationTaxCalculationWithCache(
sessionId?: string,
taxItemId?: string,
isExternalCall: boolean = false,
requestBody?: Wealthlane_TaxService_Dtos_ParticipantTransaction_ParticipantTransaction,
): CancelablePromise<Array<Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/tax-calculation-with-cache',
            query: {
                'sessionId': sessionId,
                'TaxItemId': taxItemId,
                'isExternalCall': isExternalCall,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationRegisterCacheSession(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/register-cache-session',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sessionId 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationClearCacheSession(
sessionId: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/clear-cache-session/{sessionId}',
            path: {
                'sessionId': sessionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationCalculateTest(): CancelablePromise<Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/calculate-test',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param ytdIncome 
     * @param transactionGainAmount 
     * @returns Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationCalculateNewTest(
ytdIncome?: number,
transactionGainAmount?: number,
): CancelablePromise<Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/calculate-new-test',
            query: {
                'ytdIncome': ytdIncome,
                'transactionGainAmount': transactionGainAmount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationUsingImportDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationTaxCalculationUsingImport(
formData?: {
File?: Blob;
TaxItemId?: string;
},
): CancelablePromise<Array<Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationUsingImportDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/tax-calculation-using-import',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationTestBlobDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationDownloadTaxCalculationTestSample(): CancelablePromise<Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationTestBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/download-tax-calculation-test-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationUploadTaxCalculationTestSample(
formData?: {
document?: Blob;
},
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/upload-tax-calculation-test-sample',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sessionId 
     * @param taxItemId 
     * @param tenantId 
     * @param isExternalCall 
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseListDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationTaxCalculationListWithCache(
sessionId?: string,
taxItemId?: string,
tenantId?: string,
isExternalCall: boolean = false,
requestBody?: Array<Wealthlane_TaxService_Dtos_ParticipantTransaction_ParticipantTransaction>,
): CancelablePromise<Array<Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseListDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/tax-calculation-list-with-cache',
            query: {
                'sessionId': sessionId,
                'TaxItemId': taxItemId,
                'TenantId': tenantId,
                'isExternalCall': isExternalCall,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sessionId 
     * @param taxItemId 
     * @param tenantId 
     * @param isExternalCall 
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseListDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationTaxCalculationListWithCacheV2(
sessionId?: string,
taxItemId?: string,
tenantId?: string,
isExternalCall: boolean = false,
requestBody?: Array<Wealthlane_TaxService_Dtos_ParticipantTransaction_ParticipantTransaction>,
): CancelablePromise<Array<Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationResponseListDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/tax-calculation-list-with-cache-v2',
            query: {
                'sessionId': sessionId,
                'TaxItemId': taxItemId,
                'TenantId': tenantId,
                'isExternalCall': isExternalCall,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param approvedStatusId 
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxBracketsForCalculationDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationFilterApplicableTaxes(
approvedStatusId: number,
requestBody?: Wealthlane_TaxService_Dtos_ParticipantTransaction_ParticipantTransaction,
): CancelablePromise<Array<Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxBracketsForCalculationDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/filter-applicable-taxes/{approvedStatusId}',
            path: {
                'approvedStatusId': approvedStatusId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param request 
     * @returns Wealthlane_Shared_Hosting_TaxService_Grpc_ParticpantsListTaxRateResponse OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxCalculationTestTaxCalculation(
request?: string,
): CancelablePromise<Wealthlane_Shared_Hosting_TaxService_Grpc_ParticpantsListTaxRateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-calculation/test-tax-calculation',
            query: {
                'request': request,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
